import { render } from "./PrimaryCareCommunityOrganization.vue?vue&type=template&id=aa80aaf2&scoped=true&lang=pug"
import script from "./PrimaryCareCommunityOrganization.vue?vue&type=script&lang=js"
export * from "./PrimaryCareCommunityOrganization.vue?vue&type=script&lang=js"

import "./PrimaryCareCommunityOrganization.vue?vue&type=style&index=0&id=aa80aaf2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa80aaf2"]])

export default __exports__